import React, { Component } from "react";
import DataManager from "../../module/DataManager";

export default class Login extends Component {
  state = {
    userName: "",
    password: ""
  };

  handleFieldChange = evt => {
    const stateToChange = {};
    stateToChange[evt.target.id] = evt.target.value;
    this.setState(stateToChange);
  };

  handleLogin = e => {
    e.preventDefault();
    window.alert("LOGIN handler fired");
    DataManager.getAll("users").then(users => {
      window.alert("Data loaded");
      const singleUser = users.find(
        element =>
          element.userName.toLowerCase() ===
            this.state.userName.toLowerCase() &&
          element.password.toLowerCase() === this.state.password.toLowerCase()
      );
      if (singleUser) {
        window.alert("User found");
        sessionStorage.setItem("userId", singleUser.id);
        this.props.history.push("/foods");
        this.props.makeMacrosArrs();
      } else {
        window.alert(
          "Invalid login information. Please try again or register a new account."
        );
      }
    }).catch(err => {window.alert("ERROR: " + err);
      });
  };

  render() {
    return (
      <form className="d-flex flex-column" onSubmit={this.handleLogin}>
        <h1 className="d-flex h4 mb-3 font-weight-normal justify-content-center">
          Please Sign In
        </h1>
        <div className="d-flex justify-content-center">
          <label htmlFor="inputUserName">User Name:&nbsp;</label>
          <input
            onChange={this.handleFieldChange}
            type="text"
            id="userName"
            placeholder="User Name"
            required=""
          />
        </div>
        &nbsp;
        <div className="d-flex justify-content-center">
          <label htmlFor="inputPassword">Password:&nbsp;</label>
          <input
            onChange={this.handleFieldChange}
            type="password"
            id="password"
            placeholder="Password"
            required=""
          />
        </div>
        &nbsp;
        <div className="d-flex justify-content-center">
          <button type="submit" className="btn btn-info btn-sm login-button">
            Sign in
          </button>
          &nbsp;
          <button
            type="button"
            className="btn btn-secondary btn-sm"
            onClick={() => this.props.history.push("/register")}
          >
            Register New Account
          </button>
        </div>
      </form>
    );
  }
}
